import { useAppSelector } from '@hooks/useRedux';
import { AccessControlCode } from '@shared/constants';
import { selectHasAccessControl } from '@store/auth/authSelectors';
import {
  AccommodationBooking,
  AccommodationBookingStatus,
} from '../../types/accommodation';

// Rates and payments are only correctable before check-in; the database
// enforces the same rule in lock_booking_for_financial_edit().
const FINANCIAL_EDIT_STATUSES: AccommodationBookingStatus[] = [
  'pending',
  'confirmed',
];

const selectCanEditBookingFinancials = selectHasAccessControl(
  AccessControlCode.ACCOMMODATION_BOOKINGS_FINANCIAL_EDIT,
);

export function useCanEditBookingFinancials(
  booking: Pick<AccommodationBooking, 'status'> | null | undefined,
) {
  const hasPermission = useAppSelector(selectCanEditBookingFinancials);
  const isEditableStatus = Boolean(
    booking && FINANCIAL_EDIT_STATUSES.includes(booking.status),
  );

  return {
    canEdit: hasPermission && isEditableStatus,
    hasPermission,
    isEditableStatus,
  };
}
